import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import { useContext } from 'react';
import { AuthContext } from '../context/Authcontext';

// Screen imports
import Users from '../pages/screens/users/Users';
import Pandits from '../pages/screens/pandits/Pandits';
import Departments from '../pages/screens/departments/Departments';
import Events from '../pages/screens/events/Events';
import Quizzes from '../pages/screens/quizzes/Quizzes';
import Prayers from '../pages/screens/prayers/Prayers';
import DailyPrayers from '../pages/screens/dailyprayers/DailyPrayers';
import SpecialDays from '../pages/screens/specialdays/SpecialDays';
import Mandirs from '../pages/screens/mandirs/Mandirs';
import HindiLearning from '../pages/screens/hindilearning/HindiLearning';
import Kinderhuis from '../pages/screens/kinderhuis/Kinderhuis';
import EBibliotheek from '../pages/screens/ebibliotheek/EBibliotheek';
import DharmaLearning from '../pages/screens/dharmalearning/DharmaLearning';
import Schools from '../pages/screens/schools/Schools';
import Hoofdbestuur from '../pages/screens/hoofdbestuur/Hoofdbestuur';
import Blogs from '../pages/screens/blogs/Blogs';
import Kyun from '../pages/screens/kyun/Kyun';
import DailyQuotes from '../pages/screens/dailyquotes/DailyQuotes';
import Bhojan from '../pages/screens/bhojan/Bhojan';
import Yoga from '../pages/screens/yoga/Yoga';
import Mail from '../pages/screens/mail/Mail';
import Roles from '../pages/screens/roles/Roles';
import AppGroups from '../pages/screens/appgroups/AppGroups';
import Branding from '../pages/screens/branding/Branding';
import Sidebar from '../components/Sidebar/Sidebar';
import { sectionFromPath } from '../utils/permissions';

function NoAccess() {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <h1>Geen toegang</h1>
        <p className="dashboard-intro">
          Uw rol geeft geen toegang tot dit onderdeel. Vraag een admin om uw rechten aan te passen.
        </p>
      </main>
    </div>
  );
}

function PrivateRoute({ children }) {
  const { user, loading, can } = useContext(AuthContext);
  const location = useLocation();
  if (loading) {
    return <div style={{ padding: "32px", color: "#a74800" }}>Loading admin session...</div>;
  }
  if (!user) return <Navigate to="/" />;

  const section = sectionFromPath(location.pathname);
  const required = section ? (section.viewPermission || `${section.module}.view`) : null;
  if (required && !can(required)) return <NoAccess />;

  return children;
}

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        {/* Admin Routes */}
        <Route
          path="/admin/users"
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/pandits"
          element={
            <PrivateRoute>
              <Pandits />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/departments"
          element={
            <PrivateRoute>
              <Departments />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/events"
          element={
            <PrivateRoute>
              <Events />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/quizzes"
          element={
            <PrivateRoute>
              <Quizzes />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/prayers"
          element={
            <PrivateRoute>
              <Prayers />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/dailyprayers"
          element={
            <PrivateRoute>
              <DailyPrayers />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/specialdays"
          element={
            <PrivateRoute>
              <SpecialDays />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/mandirs"
          element={
            <PrivateRoute>
              <Mandirs />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/hindilearning"
          element={
            <PrivateRoute>
              <HindiLearning />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/kinderhuis"
          element={
            <PrivateRoute>
              <Kinderhuis />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/ebibliotheek"
          element={
            <PrivateRoute>
              <EBibliotheek />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/dharmalearning"
          element={
            <PrivateRoute>
              <DharmaLearning />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/schools"
          element={
            <PrivateRoute>
              <Schools />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/hoofdbestuur"
          element={
            <PrivateRoute>
              <Hoofdbestuur />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/blogs"
          element={
            <PrivateRoute>
              <Blogs />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/kyun"
          element={
            <PrivateRoute>
              <Kyun />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/dailyquotes"
          element={
            <PrivateRoute>
              <DailyQuotes />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/bhojan"
          element={
            <PrivateRoute>
              <Bhojan />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/yoga"
          element={
            <PrivateRoute>
              <Yoga />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/roles"
          element={
            <PrivateRoute>
              <Roles />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/appgroups"
          element={
            <PrivateRoute>
              <AppGroups />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/branding"
          element={
            <PrivateRoute>
              <Branding />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/mail"
          element={
            <PrivateRoute>
              <Mail />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}
